import { useEffect, type ReactNode } from "react";
import { X } from "lucide-react";

interface ModalProps { open: boolean; title: string; children: ReactNode; className?: string; onClose(): void }

export function Modal({ open, title, children, className = "", onClose }: ModalProps) {
  useEffect(() => {
    if (!open) return;
    const close = (event: KeyboardEvent) => { if (event.key === "Escape") onClose(); };
    document.addEventListener("keydown", close);
    document.body.classList.add("modal-open");
    return () => { document.removeEventListener("keydown", close); document.body.classList.remove("modal-open"); };
  }, [open, onClose]);
  if (!open) return null;
  return <div className="modal-backdrop" role="presentation" onMouseDown={(event) => { if (event.currentTarget === event.target) onClose(); }}>
    <section className={`modal ${className}`} role="dialog" aria-modal="true" aria-labelledby="modal-title">
      <header className="modal-header"><div><span className="eyebrow">POSITRONICO</span><h2 id="modal-title">{title}</h2></div><button className="icon-button" onClick={onClose} aria-label="Cerrar"><X size={19}/></button></header>
      {children}
    </section>
  </div>;
}

export function FormActions({ onCancel, submitLabel = "Guardar cambios" }: { onCancel(): void; submitLabel?: string }) {
  return <div className="form-actions"><button type="button" className="button secondary" onClick={onCancel}>Cancelar</button><button type="submit" className="button primary">{submitLabel}</button></div>;
}
